import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_FORMAT } from '../helpers/DateHelper';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class JobListRow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {job, intl} = this.props;
        return (
            <tr className={'job-item'} key={job.id} data-job-id={job.id}>
                <td className="align-middle">{job.title}</td>
                <td className="align-middle">{moment.unix(job.created).format(DATE_FORMAT)}</td>
                <td className="align-middle">{moment.unix(job.endTime).format(DATE_FORMAT)}</td>
                <td className="list-actions text-right align-middle">
                    <div className="btn-group">
                        <Link
                            to={"/jobopslag/redigere/"+job.id}
                            title="Rediger"
                            className="btn btn-secondary waves-effect list-action"
                        >
                            <i className="fa fa-pencil"/>{intl.formatMessage(messages.listDropDownButtonEdit)}
                        </Link>
                        <button
                            type="button"
                            className="btn clickable btn-secondary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                        </button>
                        <div className="dropdown-menu">
                            <button title={intl.formatMessage(messages.listDropDownButtonClone)}
                                    type="button"
                                    className="dropdown-item clickable"
                                    onClick={this.props.cloneJob}
                            >
                                <i className="fa fa-clone"/>{intl.formatMessage(messages.listDropDownButtonClone)}
                            </button>
                            <Link
                                to={"/jobopslag/vis/"+job.id}
                                title={intl.formatMessage(messages.listDropDownButtonView)}
                                className="dropdown-item clickable"
                            >
                                <i className="fa fa-eye"/> {intl.formatMessage(messages.listDropDownButtonView)}
                            </Link>
                            <div className="dropdown-divider"/>
                            <button
                                title={intl.formatMessage(messages.listDropDownButtonDelete)}
                                type="button"
                                className="dropdown-item clickable"
                                onClick={this.props.showJobDeleteModal}
                            >
                                <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        )
    }
}

export default injectIntl(JobListRow);




// WEBPACK FOOTER //
// ./web/src/components/jobs/JobListRow.jsx